import $ from 'jquery';
import React, { useEffect, useState } from 'react';
import Toastr from 'toastr';
import Loading from '../components/Loading';
import SessionManager from '../routes/SessionManager';

function AITextNotification() {

    const url_string = String(window.location);
    const url_parts = url_string.split('event/');
    let event_id = url_parts.length > 1 ? url_parts[1] : 0;
    let foundEvent = false;
    const [user, setUser] = useState({});

    useEffect(() => {
        var sessionMgr = new SessionManager();
        let user = sessionMgr.readCookie('user', true, '/?redirectUrl=' + window.location.pathname);
        if (user !== null) {
            setUser(user);
        }
    }, []);

    useEffect(() => {
        if (!user.site_locations) {
            fetchSiteLocations();
        } else {
            fetchAIEventDetails();
        }
    }, [user]);

    const fetchSiteLocations = () => {
        var data = {
            customer_id: user.customer_id,
            site_id: user.user_sites,
            user_login: user.user_login,
            user_token: user.user_token
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/site',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    let site_locations = res.data ? res.data.filter(x => x.site_state.trim().toUpperCase() !== 'INACTIVE') : [];
                    let loc = 'site_name';
                    site_locations = site_locations.sort((a, b) => a[loc] > b[loc] ? 1 : a[loc] < b[loc] ? -1 : 0);

                    let userCopy = JSON.parse(JSON.stringify(user));
                    userCopy.site_locations = site_locations;

                    if (site_locations && site_locations.length > 0) {
                        let siteDefault = getDefaultSite(site_locations);
                        if (siteDefault) {
                            userCopy.site_selected = siteDefault;
                            var sessionMgr = new SessionManager();
                            sessionMgr.storeCookie('user', userCopy);
                        }

                        setUser(userCopy);
                    } else {
                        sessionMgr.storeCookie('user', user);
                        Toastr.error('No Sites Found ...');
                        window.location = './message';
                    }
                }
            },
        );
    }

    const getDefaultSite = (site_locations) => {
        var siteDefault = null;
        let defaultSiteId = user.site_id; //Default Site;

        if (user.site_selected)
            defaultSiteId = user.site_selected.site_id;

        if (defaultSiteId) {
            for (let s of site_locations)
                if (String(s.site_id) === String(defaultSiteId)) {
                    siteDefault = s;
                    break;
                }
        }

        if (!siteDefault)
            siteDefault = site_locations[0];

        return siteDefault;
    }

    const fetchAIEventDetails = () => {
        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            source: "D",
            criteria: {
                from: 0,
                size: 1,
                event_id: event_id
            }
        };

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/event_tmp/fetch',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            async (res) => {
                if (res && res.status && res.status.code === 200) {
                    var data = res.data.records;
                    let event_record = data.length > 0 ? data[0] : null;
                    if (event_record === null) {
                        Toastr.error('Notification link expired or invalid ...');
                        setTimeout(() => {
                            window.location = '../dashboard';
                        }, 4000)
                    } else {
                        let site = user.site_locations && user.site_locations.find(s => String(s.site_id) === String(event_record.site_id));
                        if (site) {
                            let _user = JSON.parse(JSON.stringify(user));
                            if (user.site_selected && user.site_selected.site_id !== event_record.site_id) {
                                _user.site_selected = site;
                                let zones = await fetchSiteLocationZones(site.site_id);
                                _user.zones = zones;
                            } else {
                                let _zone_selected = _user.zones && _user.zones.find(z => z.location_id === event_record.location_id);
                                if (!_user.zones || _user.zones.length === 0 || _zone_selected === undefined || !_zone_selected) {
                                    let zones = await fetchSiteLocationZones(site.site_id);
                                    _user.zones = zones;
                                }
                            }

                            let _zone_selected = _user.zones.find(z => z.location_id === event_record.location_id);
                            if (_zone_selected)
                                _user.zone_selected = _zone_selected;


                            _user.ai_event = event_record;
                            var sessionMgr = new SessionManager();
                            sessionMgr.storeCookie('user', _user);

                            if (event_record.link_level !== "sensor" && event_record.link_level !== "site") {
                                if (!_zone_selected) {
                                    Toastr.error('Not authorized to view notification details ...');
                                    setTimeout(() => {
                                        window.location = '../dashboard';
                                    }, 4000);
                                }
                            }

                            if (event_record.link_level === "sensor") {
                                window.location = '../sensors-dashboard';
                            } else if (event_record.link_level === "site") {
                                window.location = '../dashboard';
                            } else {
                                window.location = '../dashboard/zone-history';
                            }

                        } else {
                            Toastr.error('Not authorized to view notification details ...');
                            setTimeout(() => {
                                window.location = '../dashboard';
                            }, 4000);
                        }
                    }
                } else {
                    Toastr.error('Notification link expired or invalid ...');
                    setTimeout(() => {
                        window.location = '../dashboard';
                    }, 4000)
                }
            }
        );

    }

    const fetchSiteLocationZones = async (site_id = user.site_selected.site_id) => {
        return new Promise((resolve, reject) => {
            var data = {
                customer_id: user.customer_id,
                site_id: site_id,
                user_login: user.user_login,
                user_token: user.user_token
            }
            $.ajax(
                {
                    url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/location',
                    type: 'POST',
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    data: JSON.stringify(data)
                }
            ).then(
                (res) => {
                    if (res && res.status && res.status.code === 200) {
                        if (res.data && res.data.length > 0) {
                            let zone_prefs = user.zone_prefs;
                            if (zone_prefs && zone_prefs.length > 0) {
                                res.data.sort((a, b) => {
                                    return zone_prefs.indexOf(a.location_id) - zone_prefs.indexOf(b.location_id);
                                });
                            }
                            resolve(res.data)
                        } else {
                            resolve([]);
                        }
                    } else {
                        resolve([]);
                    }
                },
                (res) => {
                    resolve([]);
                });
        });
    }

    return (
        <React.Fragment>
            <div id="loginContainer" className="container-fluid" style={{ marginTop: '80px' }}>
                {!foundEvent && <Loading>Fetching Notification Event Information ...</Loading>}
            </div>
        </React.Fragment>
    );
}

export default AITextNotification;